import React from 'react';
import { Loader } from './loader';
import { Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loaderOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '99vw',
      height: '99vh',
      zIndex: 999999,
      backgroundColor: 'rgba(0,0,0,0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })
);
export default function LoaderOverlay() {
  const classes = useStyles();
  return (
    <div className={classes.loaderOverlay}>
      <Loader size={80} />
    </div>
  );
}
